import { FacilityBaleOutboundPage } from '@/pages/facility/workflows/bale-outbound';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/bale-outbound')({
	component: FacilityBaleOutboundPage,
});
